export const version = { major: 1, minor: 1, build: 24 };
